import { render, staticRenderFns } from "./ManageMizodiaCustom.vue?vue&type=template&id=0e492db2&"
import script from "./ManageMizodiaCustom.vue?vue&type=script&lang=js&"
export * from "./ManageMizodiaCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports